import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { toast } from 'react-toastify';

import {
  chargeTakeawayOrder,
  type ChargeTakeawayOrderPayload,
} from '../api/orders';

interface ChargeVariables {
  id: string | number;
  payload: ChargeTakeawayOrderPayload;
}

interface ApiError {
  message?: string;
}

export function useChargeTakeawayOrder() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: ChargeVariables) => chargeTakeawayOrder(id, payload),
    onSuccess: (_data, variables) => {
      toast.success('Pedido cobrado exitosamente');
      queryClient.invalidateQueries({ queryKey: ['takeaway', 'list'] });
      queryClient.invalidateQueries({ queryKey: ['takeaway', 'detail', variables.id] });
    },
    onError: (error: AxiosError<ApiError>) => {
      const message = error.response?.data?.message;
      toast.error(message ?? 'No se pudo cobrar el pedido');
    },
  });
}
